import React from 'react';
import {View} from 'react-native';
import {useTheme} from '../../../theme';
import styles from './styles';

const Divider = ({height = 1, color, top = 10, style = {}}) => {
  // Themed DEFAULT only (legacy grey4 → borderMuted; identical in light).
  // Callers that pass an explicit color are honored untouched.
  const {colors} = useTheme();
  const resolvedColor = color === undefined ? colors.borderMuted : color;
  return (
    <View style={[styles.dividerStyle(resolvedColor, top, height), style]} />
  );
};

export default Divider;
